import { useState } from "react";
import { useSelector } from "react-redux";
import SendApplicationButton from "../../../components/ui/buttons/SendApplicationButton";

const SendLoanApplicationsDropdownButton = () => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const user = useSelector((state) => state.user);
  const users = useSelector((state) => state.users);
  const userId = users?.find((u) => u.emailAddress === user?.emailAddress)?._id;

  const loanId = loanDrilldown?._id;

  const [show, setShow] = useState(false);
  return (
    <>
      <SendApplicationButton
        size="small"
        modalTitle="Send Loan App"
        urlText="Loan App URL"
        href={`loan-application?userId=${userId}&loanId=${loanId}`}
        onClose={() => setShow(false)}
        show={show === "loan"}
      >
        Send Loan App
      </SendApplicationButton>
    </>
  );
};
export default SendLoanApplicationsDropdownButton;
